export default __webpack_public_path__ + "static/media/main.c15b52bc.svg";